//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    discountInt: {
      type: Number,
      default: 0,
    },
    percent: {
      type: Number,
      default: 0,
    },
    name: {
      type: String,
      default: null,
    },
    price: {
      type: String,
      default: '0',
    },
    variant: {
      type: String,
      default: 'a',
    },
  },
  computed: {
    discount() {
      const percent = `${this.percent}%`;
      let discountString = percent;

      if (this.discountInt) {
        const currencySign = `${this.$t('currencySign')}`;
        const discountInt = `${currencySign} ${this.discountInt}`;
        discountString = `${discountString} + ${discountInt}`;
      }

      return discountString;
    },
    monthPrice() {
      const price = +this.price || 0;
      return (price / 12).toFixed(2);
    },
  },
};
